import { render, staticRenderFns } from "./radio-group.vue?vue&type=template&id=52675c8e&"
import script from "./radio-group.vue?vue&type=script&lang=js&"
export * from "./radio-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52675c8e')) {
      api.createRecord('52675c8e', component.options)
    } else {
      api.reload('52675c8e', component.options)
    }
    module.hot.accept("./radio-group.vue?vue&type=template&id=52675c8e&", function () {
      api.rerender('52675c8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/radio/radio-group.vue"
export default component.exports